import styled from "styled-components";

export const StyledContact = styled.div`
    .contact-header{
        position: relative;
        overflow: hidden;

        .shadow{
            position: absolute;
            width: 100%;
            top:0;
            background-color: rgba(0,0,0,0.4);
            height: 100%;
        }
        .contact-video{
            position: absolute;
            min-height: 100%;
            min-width: 100%;
            z-index: -2;
        }
    }
    .contact-main{
        text-align: center;
        padding: 250px 0 450px 0;
        color: white;
        position: relative;
        z-index: 2;

        h1{
            font-weight: 700;
            font-size: 96px;
            line-height: 131px;
        }

        p{
            font-size: 32px;
            line-height: 44px;
            /* margin-top: 30px; */
            width: 30%;
            margin: 30px auto;
        }
        @media (max-width:992px) {
            h1{
                font-size: 60px;
            }
            p{
                font-size: 20px;
                width: 100%;
            }
        }
        @media (max-width:576px) {
            padding: 300px 0;
            h1{
                font-size: 40px;
                line-height: 54px;
            }
            p{
                margin-top: 15px;
                font-size: 16px;
                line-height: 22px;
            }
        }
    }

    .section-contact{
        margin-top: 70px;

        h2{
            font-weight: 600;
            font-size: 18px;
            line-height: 25px;
            letter-spacing: 0.06em;
            color: #BB0600;
            margin: 16px 0;
        }

        .contact{
            display: flex;

            .contact-left{
                padding: 30px;
                background: #F5F5F5;
                width: 30%;

                .social{
                    display: flex;
                    align-items: center;
                    gap: 28px;

                    svg{
                        path{
                            fill: #2F3A4E;

                        }
                    }
                }

                .contact-item{
                    display: flex;
                    gap:18px;
                    margin-bottom: 40px;

                    h3{
                        font-weight: 600;
                        font-size: 18px;
                        line-height: 25px;
                        letter-spacing: 0.06em;
                        color: #2F3A4E;
                        margin-bottom: 10px ;
                    }

                    a{
                        line-height: 25px;
                        letter-spacing: 0.06em;
                        color: #353535;
                        text-decoration: none
                    }
                }
            }

            .contact-right{
                width: 70%;
                position: relative;
                overflow-y: hidden;
                img{
                    width: 100%;
                    position: absolute;
                    display: ${({open})=> open ? "block": "none"};
                }
                video{
                    width: 100%;
                }
            }
        }
        @media (max-width: 1440px) {
            .contact{
                flex-direction: column-reverse;
                .contact-right, .contact-left{
                    width: 100%;
                }
            }
        }
        @media (max-width:576px) {
            .contact{
                .contact-left{
                    background: #fff;
                    padding: 30px 0;
                    .contact-item{
                        margin-bottom: 25px;
                    }
                }
            }
            h2{
                margin-top: 0;
            }
        }   
    }

    .section-send{

        .send{
            padding-right: 100px;
            
            .form{
                margin-top: 50px;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                input{
                    background: #EBEBEB;
                    border-radius: 8px;
                    width: 30%;
                    padding: 14px 20px;
                    font-size: 16px;
                    line-height: 22px;
                    letter-spacing: 0.06em;
                    border: none;
                    outline: none;
                    display: inline-block;
                    margin-bottom: 25px;
                    &::placeholder{
                        color: #838383;
                    }
                }
                textarea{
                    display: inline-block;
                    width: 100%;
                    background: #EBEBEB;
                    border-radius: 8px;
                    min-height: 180px;
                    border: none;
                    outline: none;
                    padding: 15px;
                    line-height: 22px;
                    letter-spacing: 0.06em;
                    color: #838383;
                    font-size: 16px;
                    margin-top: 50px;
                    margin-bottom: 40px;
                }
                button{
                    background: #BB0600;
                    border-radius: 8px;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 22px;
                    color: #FFFFFF;
                    padding: 14px 44px;
                    border: none;
                    cursor: pointer;
                }
            }

            @media (max-width: 1200px) {
                padding-right: 0;
            }
            @media (max-width: 768px) {
                display: block;
                .form{
                    margin-top: 20px;
                    input{
                        width: 100%;
                    }
                    textarea{
                        margin-top:0 ;
                    }
                }
            }
        }
    }

    .section-google{
        margin-top: 50px;
        iframe{
            width: 100%;
            height: 660px;
        }
        @media (max-width: 576px) {
            iframe{
                height: 420px;
            }
        }
    }

`  